import { useRouter } from 'next/router';
import React from 'react';
import { useAppBanner } from 'src/hooks/useAppBanner';
import { checkLocaleCn } from 'src/utils/locale';
import { toJSX } from 'src/utils/toJSXHelper';
import styles from './index.module.scss';
import { Presenter } from './Presenter';

export const AppLeadingBanner: React.FC = () => {
  const { locale } = useRouter();

  const {
    isFollowingDayAccess,
    productPageViewMoreThanThree,
    localeResources,
    handleClose,
    handleDownloadButtonClick
  } = useAppBanner();

  if (!isFollowingDayAccess && !productPageViewMoreThanThree) {
    return null;
  }

  if (checkLocaleCn(locale)) {
    return null;
  }

  return (
    <Presenter
      title={toJSX(localeResources.nativeApp.badge.title(styles.pink))}
      downloadText={localeResources.commons.download}
      handleClose={handleClose}
      handleDownloadButtonClick={handleDownloadButtonClick}
    />
  );
};
